import { copyToClipboard } from '../../js/shared/utils';

document.addEventListener('click', (e) => {
    const targetElement = e.target.closest('.js-contacts-copy');
    if (targetElement) {
        const parent = targetElement.closest('.js-contacts');
        if (parent) {
            const link = parent.querySelector('a');
            const defaultEl = parent.querySelector('.js-contacts-primary');
            const secondaryEl = parent.querySelector('.js-contacts-secondary');

            if (link) {
                // В регулярке удаляем все символы до ":" включая ":" и пробелы в начале/конце
                const url = (link.href).replace(/^\s*[^:]+:\s*/, '');

                copyToClipboard(url);

                if (defaultEl && secondaryEl) {
                    parent.classList.add('is-disabled');
                    setTimeout(function () {
                        parent.classList.remove('is-disabled');
                    }, 3000);
                }
            }
        }
    }
});

